module.exports = __webpack_public_path__ + "cf.logo.fb79f.svg";